import axios from 'axios';

export default class Companies {

	static axiosCancelToken = axios.CancelToken.source();
	
	static list = (params = {}) => {
		this.newAxiosCancelToken();

		return axios.get('api/companies/list', {
			params: params,
			cancelToken: this.axiosCancelToken.token
		}).then((response) => {
			return response.data;
		}).catch((error) => {
			if ( axios.isCancel(error) ) return null;
		});
	}
	
	static get = (id) => {
		this.newAxiosCancelToken();

		return axios.get('api/companies/get/' + id, {
			params: {},
			cancelToken: this.axiosCancelToken.token
		}).then((response) => {
			return response.data;
		}).catch((error) => {
			if ( axios.isCancel(error) ) return null;
		});
	}

	static cancel = () => {
		this.axiosCancelToken.cancel();
	}

	static newAxiosCancelToken = () => {
		this.axiosCancelToken = axios.CancelToken.source();
	}
	
}